(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/system-row.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/system-row.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.numbergames.game.views.SystemRow = Marionette.View.extend({
  ballRowSize: 300,
  modelEvents() {
    const events = {
      'number:added': 'addNumber',
      'huxflux:added': 'addHuxfluxedNumber',
      'number:removed huxflux:removed': 'removeNumber',
      'numbers:removed:all': 'clearAll'
    };
    if (this.isKeno) {
      return _objectSpread(_objectSpread({}, events), {}, {
        'change:board change:level change:hasKungKeno': 'updateWinPlan',
        'change:level': 'changedLevel',
        'change:hasKungKeno': 'changeHasKungKeno'
      });
    }
    return events;
  },
  template(_ref) {
    let {
      row
    } = _ref;
    return row.render();
  },
  templateContext() {
    return {
      row: this.row
    };
  },
  initialize() {
    this.isKeno = svs.numbergames.productMapping.isKeno(this.model.get('productId'));
    this.multipliedRowPrice = this.options.multipliedRowPrice;
    const ballRowOptions = {
      size: this.getOption('ballRowSize'),
      isValid: !this.model.has('level') || Boolean(this.model.get('level')),
      kungKeno: this.model.get('hasKungKeno'),
      numbers: this.model.get('level'),
      isSystem: true
    };
    if (this.isKeno) ballRowOptions.winPlan = new svs.tur.ball.row.extensions.WinPlan(this.getWinPlanText());
    const ballrowBranding = svs.numbergames.productMapping.getProductName(this.model.get('productId'));
    const BallRow = svs.tur.ball.row.play[ballrowBranding] || svs.tur.ball.row.play.Default;
    this.row = new BallRow(ballRowOptions);
    if (!this.model.get('isEmpty')) {
      const {
        numbers,
        numbersExtra
      } = this.model.getNumberListArrays();
      if (numbers.length) {
        numbers.forEach((number, index) => {
          this.row.add({
            index,
            number
          });
        });
      }
      if (numbersExtra && numbersExtra.length) {
        numbersExtra.forEach((number, index) => {
          this.row.add({
            index,
            number,
            extraNumber: true
          });
        });
      }
    }
  },
  addNumber(board, _ref2) {
    let {
      number,
      index,
      isExtra
    } = _ref2;
    this.row.add({
      number,
      index,
      extraNumber: isExtra
    });
  },
  addHuxfluxedNumber(board, _ref3) {
    let {
      number,
      index,
      isExtra
    } = _ref3;
    this.row.addHuxfluxed({
      number,
      index,
      extraNumber: isExtra
    });
  },
  removeNumber(board, _ref4) {
    let {
      number,
      index,
      isExtra
    } = _ref4;
    this.row.remove({
      number,
      index,
      extraNumber: isExtra
    });
  },
  clearAll() {
    this.row.clearAll();
  },
  changeHasKungKeno(model, hasKungKeno) {
    this.row.toggleKungKeno(hasKungKeno);
  },
  changedLevel(model, level) {
    this.row.valid = Boolean(level);
  },
  getWinPlanText(multipliedRowPrice) {
    if (!multipliedRowPrice) multipliedRowPrice = this.multipliedRowPrice;
    let title = '&nbsp;';
    let description = '';
    const level = this.model.get('level');
    if (level && this.model.get('isValid')) {
      const {
        getLevelWinPlanTopWin,
        types
      } = svs.numbergames.rules.utils.keno_winplan;
      const type = types.KENO_SYSTEM;
      const hasKungKeno = this.model.get('hasKungKeno');
      const maxWin = getLevelWinPlanTopWin({
        type,
        level,
        rowPrice: this.multipliedRowPrice,
        hasKungKeno,
        systemNumbers: this.model.get('numbers').length
      });
      title = "Keno ".concat(level);
      description = "- Toppvinst ".concat(svs.utils.format.Currency(maxWin), " kr");
    }
    return {
      title,
      description
    };
  },
  updateWinPlan(multipliedRowPrice) {
    if (this.row.row && this.row.row.winPlan) {
      this.row.row.winPlan.update(this.getWinPlanText(multipliedRowPrice));
    }
  },
  onUpdateMultipliedRowPrice(multipliedRowPrice) {
    this.multipliedRowPrice = multipliedRowPrice;
    this.updateWinPlan();
  }
});

 })(window);